import React from 'react';

import { RadioWithLabel, Typography, PriceBlock } from '@hpstellar/core';

import { withError } from '../../../shared/components/error-boundary';
import useProductPrice from '../../../hooks/useProductPrice';
import PrinterCartridgeColor from './printer-cartridge-color';
import PrinterCartridgePageYield from './printer-cartridge-pageyield';

import './supplies-card.less';

const ConfigCard = ({ config, price }) => {
    const { name, product_type = 'CTO' } = config;
    const productType = product_type.toLowerCase();
    const { salePrice, regularPrice } = price || {};
    return (
        <div className="similar-supplies-card">
            <Typography tag="h3" variant="headingSubheader" className="product-name">
                {name}
            </Typography>
            <div className="cartridge-info">
                <PrinterCartridgeColor product={config} />
                <PrinterCartridgePageYield product={config} price={price} />
            </div>
            <PriceBlock
                size="medium"
                style="left"
                priceDifference={regularPrice - salePrice}
                salePrice={salePrice}
                regularPrice={regularPrice}
                productType={productType}
            />
        </div>
    );
};

export default withError(({ options = [], selectedOption, onChange, title, modalClose }) => {
    const { prices } = useProductPrice(options);
    return (
        <div className="similar-supplies-container">
            {title && (
                <Typography tag="h2" variant="headingSubheader" className="group-title">
                    {title}
                </Typography>
            )}
            {options.map((option, i) => {
                const { value, checked } = option;
                return (
                    <RadioWithLabel
                        key={`${value}-${checked}-${i}`}
                        checked={checked}
                        className={checked && 'active-radio'}
                        broad
                    >
                        <RadioWithLabel.Label className="radio-container">
                            <ConfigCard config={option} price={prices[option.sku]} />
                            <RadioWithLabel.Input
                                value={value}
                                onChange={e => {
                                    onChange(e?.target?.value);
                                    modalClose();
                                }}
                            />
                        </RadioWithLabel.Label>
                    </RadioWithLabel>
                );
            })}
        </div>
    );
});
